import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  payoutToAch,
  PayoutToAchRequest,
  PayoutToAchResponse,
} from 'api/payments'
import { paymentKeys } from './keys'

export function usePayoutToAchMutation() {
  const queryClient = useQueryClient()
  return useMutation<PayoutToAchResponse, Error, PayoutToAchRequest>({
    mutationFn: payoutToAch,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: paymentKeys.list })
      queryClient.invalidateQueries({
        queryKey: ['userPaymentProfile', variables.userId.toString()],
      })
      queryClient.invalidateQueries({
        queryKey: paymentKeys.outstandingBalanceDetail(variables.userId),
      })
    },
  })
}
